
/**
 * The angularjs states related to the module QuickReplies
 */
quickRepliesStates.$inject = ['$stateProvider', '$urlRouterProvider'];
export function quickRepliesStates($stateProvider, $urlRouterProvider) {
  $urlRouterProvider // Changing QR URLs, 2019-07-12 -- the '$n in string' syntax doesn't seem to be working with 4 matches
    .when(/^\/([0-9]+)\/parameters\/account\/([0-9]+)\/(quick-replies|campaign-scenarios)\/([0-9]+)$/,
      ['$match', function ($match) {
        return `/${$match[1]}/fuse/parameters/account/${$match[2]}/${$match[3]}/${$match[4]}`;
      }]);

  addScenarioStates($stateProvider, 'quick-replies');
  addScenarioStates($stateProvider, 'campaign-scenarios');

}


function addScenarioStates($stateProvider, scenarioFlavor) {
  $stateProvider
    .state(`auth.alcmeon.fuse.parameters.all-accounts.${scenarioFlavor}`, {
      url: `/${scenarioFlavor}`,
      data: {
        isMarketingMode: scenarioFlavor === 'campaign-scenarios'
      },
      views: {
        'container@auth': {
          template: '<angular-quick-replies></angular-quick-replies>',
        },
        'sub-nav@auth': { template: '' }
      }
    })
    .state(`auth.alcmeon.fuse.parameters.all-accounts.${scenarioFlavor}.create`, {
      url: `/create`,
      data: {
        isMarketingMode: scenarioFlavor === 'campaign-scenarios'
      },
      views: {
        'container@auth': {
          template: '<angular-scenario-wizard></angular-scenario-wizard>',
        },
        'sub-nav@auth': { template: '' }
      }
    })
    .state(`auth.alcmeon.fuse.parameters.all-accounts.${scenarioFlavor}.duplicate`, {
      url: `/{scenarioId:int}/duplicate`,
      data: {
        duplicate: true,
        isMarketingMode: scenarioFlavor === 'campaign-scenarios'
      },
      views: {
        'container@auth': {
          template: '<angular-scenario-wizard></angular-scenario-wizard>',
        },
        'sub-nav@auth': { template: '' }
      }
    })
    .state(`auth.alcmeon.fuse.parameters.account.${scenarioFlavor}-details`, {
      url: `/${scenarioFlavor}/{scenarioId:int}?zoomToBoxId`,
      params: {
        redirectedFromOptins: false
      },
      data: {
        isMarketingMode: scenarioFlavor === 'campaign-scenarios'
      },
      resolve: {
        showSpinner: ['AngularSpinnerService', function (AngularSpinnerService) {
          AngularSpinnerService.showSpinner();
        }],
        scenarioFlavor: () => scenarioFlavor,
        allScenarios: ['site', 'QuickRepliesFactory', 'AngularSpinnerService', function (site, QuickRepliesFactory, AngularSpinnerService) {
          AngularSpinnerService.showSpinner();
          return QuickRepliesFactory.getScenarios(site.company.id, 'all-flavors')
            .then(function (response) {
              return response.data;
            });
        }],
        scenario: ['$stateParams', 'site', 'QuickRepliesFactory', function ($stateParams, site, QuickRepliesFactory) {
          if (!site.quick_replies_enabled) {
            return {};
          }
          return QuickRepliesFactory.getScenario(site.company.id, site.id, $stateParams.scenarioId, scenarioFlavor)
            .then(function (response) {
              return response.data;
            });
        }],
        redirectedFromOptins: ['$stateParams', function ($stateParams) {
          return $stateParams.redirectedFromOptins;
        }]
      },
      views: {
        'container@auth': {
          template: require('../../../ajs-app/components/parameters/quick-replies/quick-replies.details.html'),
          controller: 'QuickRepliesDetailsController'
        },
        'sub-nav@auth': { template: '' }
      }
    });
}